import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import signatureSets from '../data/signatureSets';
import { formatPrice } from '../utils/money';
import { useCart } from '../contexts/CartContext';
import { imgSrc } from '../utils/img';
import Lightbox from '../components/Lightbox';
import '../pages/ProductDetail.css'
import Footer from '../components/Footer'

const Signature = () => {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [lightbox, setLightbox] = useState({ open: false, src: '', alt: '' });

  const handleQuickAdd = (s, e) => {
    e.stopPropagation();
    addToCart({
      slug: `signature/${s.slug}`,
      title: `Signature — ${s.title}`,
      price: formatPrice(s.priceCents),
      priceCents: s.priceCents,
      isSignature: true,
      thumbnail: s.thumbnail,
      shape: s.options?.shape?.[0] || 'Almondetto',
      length: s.options?.length?.[0] || 'Medium',
      sizes: { sizeType: 'Medium', customMode: 'fitting', measurements: null },
      addons: '',
      inspo: null,
      notes: 'Signature recreation (as shown)',
      quantity: 1,
    });
    navigate('/nails/cart');
  };

  const openDetails = (slug) => navigate(`/nails/signature/${slug}`);

  return (
    <>
    <div className="product-detail-wrapper">
      <div className="px-4 py-10 max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-center mb-2">Nail’d It Again — Signature Sets</h1>
        <h2 className="text-center max-w-xl mx-auto mb-10 mt-0 text-gray-600">
          Iconic, art-heavy designs recreated exactly as shown. Choose your shape & length.
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
          {signatureSets.map((s) => (
            <div
              key={s.id}
              role="button"
              tabIndex={0}
              onClick={() => openDetails(s.slug)}
              onKeyDown={(e) => (e.key === 'Enter' ? openDetails(s.slug) : null)}
              className="bg-white rounded-2xl shadow hover:shadow-md transition overflow-hidden flex flex-col cursor-pointer"
            >
              <div
                className="w-full h-48 overflow-hidden"
                onClick={(e) => {
                  e.stopPropagation();
                  setLightbox({ open: true, src: imgSrc(s.thumbnail), alt: s.title });
                }}
              >
                <img
                  src={imgSrc(s.thumbnail)}
                  alt={s.title}
                  className="w-full h-full object-cover cursor-zoom-in"
                  loading="lazy"
                />
              </div>

              <div className="p-4 flex-grow flex flex-col">
                <h3 className="text-lg font-semibold mb-1">{s.title}</h3>
                <p className="text-sm text-gray-600 mb-2">Signature • {formatPrice(s.priceCents)}</p>

                <div className="mt-auto flex gap-2">
                  <button className="btn-nene flex-1 whitespace-nowrap"
                    onClick={(e) => handleQuickAdd(s, e)}>
                    Quick Add
                  </button>
                  <Link
                    to={`/nails/signature/${s.slug}`}
                    className="btn-nene flex-1 text-center"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Details
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {lightbox.open && (
          <Lightbox
            src={lightbox.src}
            alt={lightbox.alt}
            onClose={() => setLightbox({ open: false, src: '', alt: '' })}
          />
        )}
      </div>
    </div>
    <Footer/>
   </>
  );
};

export default Signature;
